import {
  getKeyValue,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import { useGetAllMachineApi } from "../../hooks";
import { ShopOutlined } from "@ant-design/icons";
import { convertToVietnamTime } from "../../helper";
import { useEffect, useState } from "react";
import useDebounce from "../../hooks/common/useDebounce";
import { FooterFilterMobile } from "../../components";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store";
import path from "../../ultils/path";
import { Modal } from "antd";
import UpdateMachine from "../../components/common/UpdateMachine";

const MachinePage = () => {
  const [searchQuery, setSearchQuery] = useState<string>(""); // State for search query
  const [filteredData, setFilteredData] = useState<any>([]); // State to store filtered data
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [machineUpdate, setMachineUpdate] = useState<any>();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const { machines } = useGetAllMachineApi();

  const navigate = useNavigate();
  const { token } = useAuthStore();
  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  useEffect(() => {
    if (machines?.data) {
      const filteredItems = machines.data.filter((item: any) =>
        item?.store?.groupId
          ?.toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase())
      );
      setFilteredData(filteredItems); // Update filtered data
    }
  }, [debouncedSearchQuery, machines?.data]);

  return (
    <div className="">
      <Modal
        title={
          <div className="text-photo-time-pink-main">
            Update Machine {machineUpdate?.userName}
          </div>
        }
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <UpdateMachine
          setIsModalOpen={setIsModalOpen}
          data={machineUpdate}
        ></UpdateMachine>
      </Modal>
      <div className="w-[100%] max-sm:flex-col md:pb-2 p-[16px] md:px-[0px] font-semibold text-ok-travel-green flex pb-4 justify-between mb-2 border-b-[1.5px] md:mb-4">
        <h3 className="uppercase max-md:mt-4 text-medium text-gray-500 md:text-md xl:text-xl">
          Manage Machine
        </h3>
        <input
          className="2xl:w-[20vw] xl:w-[18vw] lg:w-[16vw] md:w-[38vw] sm:w-[40vw] max-sm:w-full placeholder:text-sm 2xl:h-[4vh] xl:h-[3.8vh] lg:h-[3.8vh] border-gray-400 font-medium outline-none px-2 rounded-md border-[1px]"
          type="text"
          placeholder="Search by Group ID..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="flex p-[16px] md:px-[0px] flex-col gap-10">
        {filteredData?.map((item: any) => {
          return (
            <div key={item?.store?.groupId}>
              <div className="flex items-center gap-2 mb-2">
                <ShopOutlined className="text-gray-500 xl:text-2xl text-base" />
                <h3 className="text-gray-500 lg:text-base text-[12px]">
                  {item?.store?.groupId} - {item?.store?.groupName} -{" "}
                  {convertToVietnamTime(item?.store?.createDate)}
                </h3>
              </div>
              <Table
                aria-label="Example table with client side pagination"
                classNames={{
                  wrapper: "min-h-[10vh]",
                  th: "text-center",
                  td: "text-center",
                }}
              >
                <TableHeader>
                  <TableColumn width={200} key="userId">
                    MACHINE ID
                  </TableColumn>
                  <TableColumn width={420} key="userName">
                    NAME
                  </TableColumn>
                  <TableColumn width={200} key="pgmType">
                    TYPE
                  </TableColumn>
                  <TableColumn width={200} key="password">
                    PASSWORD
                  </TableColumn>
                  <TableColumn
                    width={200}
                    className="max-sm:hidden"
                    key="createDate"
                  >
                    CREATED
                  </TableColumn>
                  <TableColumn width={200} key="printPaper">
                    PRINTER PAPER
                  </TableColumn>
                  {/* <TableColumn width={160} key="actions">
                    ACTION
                  </TableColumn> */}
                </TableHeader>
                <TableBody items={item.machines}>
                  {(i: any) => (
                    <TableRow key={i.userId}>
                      {(columnKey) => {
                        if (columnKey === "createDate") {
                          return (
                            <TableCell className="lg:text-[0.9rem] text-[0.8rem] max-sm:hidden">
                              {convertToVietnamTime(getKeyValue(i, columnKey))}
                            </TableCell>
                          );
                        } else if (columnKey === "pgmType") {
                          return (
                            <TableCell className="lg:text-[0.9rem] text-gray-900 text-[0.6rem]">
                              {getKeyValue(i, columnKey) === "STD" ? (
                                <p className="max-sm:text-[12px]">STANDARD</p>
                              ) : (
                                <p className="max-sm:text-[12px]">PREMIUM</p>
                              )}
                            </TableCell>
                          );
                        } else if (columnKey === "userId") {
                          return (
                            <TableCell className="lg:text-[0.9rem] font-bold text-[0.8rem] max-sm:text-[12px]">
                              {getKeyValue(i, columnKey)}
                            </TableCell>
                          );
                        } else if (columnKey === "printPaper") {
                          return (
                            <TableCell className="lg:text-[0.9rem] font-bold text-[0.8rem] max-sm:text-[12px]">
                              <div className="flex flex-col">
                                <span className="text-photo-time-pink-main">
                                  {getKeyValue(i, columnKey)}
                                </span>
                                <span
                                  onClick={() => {
                                    showModal();
                                    setMachineUpdate(i);
                                  }}
                                  className="hover:underline cursor-pointer "
                                >
                                  Reset
                                </span>
                              </div>
                            </TableCell>
                          );
                        } 
                        // else if (columnKey === "actions") {
                        //   return (
                        //     <TableCell className="lg:text-[0.9rem] text-[0.8rem] font-medium max-sm:text-[12px]">
                        //       <button
                        //         type="button"
                        //         onClick={() => {
                        //           showModal();
                        //           setMachineUpdate(i);
                        //         }}
                        //         className="bg-photo-time-pink-main text-white cursor-pointer px-3 py-1 rounded-md hover:opacity-90"
                        //       >
                        //         Update
                        //       </button>
                        //     </TableCell>
                        //   );
                        // }
                         else {
                          return (
                            <TableCell className="lg:text-[0.9rem] text-[0.8rem] font-medium max-sm:text-[12px]">
                              {getKeyValue(i, columnKey)}
                            </TableCell>
                          );
                        }
                      }}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          );
        })}
      </div>

      <FooterFilterMobile isFilter={true}></FooterFilterMobile>
    </div>
  );
};

export default MachinePage;
